const data = {
  "reviews": {
    "title": "Reviews",
    "ratings": {
      "title": "Beoordeling",
      "stars_one": "ster",
      "stars_other": "sterren"
    },
    "ratingPerSection": {
      "title": "Beoordeling per onderdeel"
    },
    "cards": {
      "expertReview": "Onze specialistenreview",
      "readFullReview": "Lees hele review",
      "mostHelpfulReviews": "Meest behulpzame reviews",
      "viewAllReviews": "Toon alle {{amount}} reviews",
      "automaticallyTranslatedFrom": "Automatisch vertaald uit",
      "writtenFor": "Geschreven voor",
      "imagesOverlayTitle": "Afbeeldingen",
      "months": {
        "10": "Oktober",
        "11": "November",
        "12": "December",
        "01": "Januari",
        "02": "Februari",
        "03": "Maart",
        "04": "April",
        "05": "Mei",
        "06": "Juni",
        "07": "Juli",
        "08": "Augustus",
        "09": "September"
      },
      "languages": {
        "nl": "Nederlands",
        "en": "Engels",
        "de": "Duits"
      }
    },
    "drawer": {
      "basedOnReviews": "Gebaseerd op {{amount}} reviews",
      "writeReview": "Schrijf een review",
      "sortBy": "Sorteren op",
      "filterOn": "Filteren op",
      "showTranslatedReviews": "Toon vertaalde beoordelingen",
      "reviewPolicy": "Reviewbeleid",
      "sortingOptions": {
        "mostHelpful": "Meest behulpzame",
        "mostStars": "Meeste sterren",
        "fewestStars": "Minste sterren",
        "newest": "Nieuwste",
        "oldest": "Oudste"
      },
      "languages": {
        "nl": "Nederlands",
        "en": "Engels",
        "de": "Duits",
        "fr": "Frans"
      },
      "title": "Reviews",
      "stickyHeader": {
        "buttonText": "In mijn winkelwagen"
      },
      "imagesGalleryTitle": "Afbeeldingen van klanten",
      "imagesOverlayTitle": "Afbeeldingen"
    },
    "images": {
      "label": "{{productFullName}} (Afbeelding {{index}} van {{total}})"
    }
  }
};

export default data;